import React, { PropTypes } from 'react'
import SearchIcon from 'react-icons/lib/md/search'

import PanelHeader from './panel-header'

const CurriculumsDefault = ({ onCurriculumForm, onSearchForm }) => {
  const header = (
    <div className="row">
      <div className="col-sm-8">
        Curriculums
      </div>
      <div className="col-sm-4 text-right">
        <button type="button" onClick={onCurriculumForm} className="btn-icon btn-inline">+</button>
        <button type="button" onClick={onSearchForm} className="btn-icon btn-inline"><SearchIcon /></button>
      </div>
    </div>
  )

  return (
    <PanelHeader header={header}>
      <div className="jumbotron">
        <h1>Curriculums</h1>
        <p>Manage curriculum subjects.</p>
        <hr />
        <button type="button" onClick={onCurriculumForm} className="btn btn-info">
          Add New Curriculum
        </button> or {' '}
        <button type="button" onClick={onSearchForm} className="btn btn-warning">
          Search Curriculum
        </button>
      </div>
    </PanelHeader>
  )
}

CurriculumsDefault.propTypes = {
  onCurriculumForm: PropTypes.func,
  onSearchForm: PropTypes.func,
}

export default CurriculumsDefault



// WEBPACK FOOTER //
// ./src/containers/Manage/Curriculums/default.js